export default __webpack_public_path__ + "static/help_06_03-3-9845e69b54270497ff899c0c6d35faf6.png";